import { Card, CardBody, Row, Col } from 'reactstrap'

function TripsResultSummary({ trips, dateCount }) {
    const totalTrips = trips.length
    const totalEarnings = trips.reduce((sum, t) => sum + (t.incomeTotal || 0), 0)
    const avgTripsPerDay = dateCount > 0 ? Math.round(totalTrips / dateCount) : 0
    const avgEarningsPerDay = dateCount > 0 ? (totalEarnings / dateCount).toFixed(2) : '0.00'

    return (
        <Card className="mb-3">
            <CardBody>
                <Row className="text-center">
                    <Col>
                        <div className="text-muted small">Total Trips</div>
                        <div className="h4 fw-bold">{totalTrips}</div>
                    </Col>
                    <Col>
                        <div className="text-muted small">Total Earnings</div>
                        <div className="h4 fw-bold">${totalEarnings.toFixed(2)}</div>
                    </Col>
                    <Col>
                        <div className="text-muted small">Avg/Day</div>
                        <div>
                            <span className="h4 fw-bold">{avgTripsPerDay} trips</span>
                            <span className="text-muted small">/${avgEarningsPerDay}</span>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

export default TripsResultSummary
